const alertTypeReasonTextMap = {
  0: "New loss-making pattern",
  1: "Action in loss-making pattern",
  2: "Risk Alert"
}

export default alertTypeReasonTextMap;